import PropTypes from 'prop-types';
// components
import OrderSeatsIOList from './seatsio/List';
import OrderVoyList from './voy/List';

Index.propTypes = {
  order: PropTypes.object
};

export default function Index({ order }) {
  switch (order.event.bookingType) {
    case 'VOY':
      return <OrderVoyList order={order} />;
    case 'SEATSIO':
      return <OrderSeatsIOList order={order} />;
    default:
      return '';
  }
}
